import styled, { css } from "styled-components";
import { getColor, getSize, responsive } from "~/helpers/style";
import Button from "../ui/Button";
import { UIProps } from "~/types/style";

export const Container = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #fff4eb;
  padding: ${getSize(1.0)};
  z-index: 2;

  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${getSize(0.8)};
  flex-wrap: wrap;

  @media (max-width: 440px) {
    padding: ${getSize(1.0)} ${getSize(2.0)} ${getSize(1.0)} ${getSize(1.5)};
    gap: ${getSize(0.6)};
  }

  ${responsive("tablet", true)} {
    bottom: 64px;
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  top: ${getSize(0.8)};
  right: ${getSize(1.6)};
  background: none;
  border: none;
  cursor: pointer;
  padding: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 3;
  opacity: 0.6;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.8;
  }

  &:active {
    opacity: 0.5;
  }

  @media (max-width: 440px) {
    top: ${getSize(1.0)};
    right: ${getSize(1.0)};
  }

  ${responsive("tablet", true)} {
    top: ${getSize(1.0)};
    right: ${getSize(1.6)};
  }
`;

export const Text = styled.span`
  font-weight: 500;
  font-size: ${getSize(1.4)};
  line-height: ${getSize(2.0)};

  @media (max-width: 440px) {
    font-size: ${getSize(1.3)};
    line-height: ${getSize(1.6)};
    padding-left: 6px;
  }
`;

export const ReconnectButton = styled(Button)`
  color: ${getColor("white")};
  background-color: #f3451f;
  border-radius: ${getSize(0.8)};
  min-width: ${getSize(9.0)};
  font-weight: 500;

  @media (max-width: 440px) {
    min-width: ${getSize(8.0)};
  }
`;

interface ISectionContainer extends UIProps {
  wrap?: boolean;
}

export const SectionContainer = styled.div<ISectionContainer>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${getSize(0.8)};
  ${({ wrap }) =>
    wrap &&
    css`
      flex-wrap: wrap;
    `}

  @media (max-width: 440px) {
    gap: 2px;

    /* Add 2px padding to the right of the icon (first child SVG) */
    > svg:first-child {
      padding-right: 2px;
    }
  }
`;
